function openTab(evt, TabName) {
    let i, tabcontent, tablinks, textTabName;
    textTabName = "text-" + TabName;
    tabcontent = document.getElementsByClassName("js-tab-content");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    document.getElementById(TabName).style.display = "block";
    document.getElementById(textTabName).style.display = "block";

    tablinks = document.getElementsByClassName("js-tab-link");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    evt.currentTarget.className += " active";
}
